import React from "react";
import { useMutation } from "react-query";
import { _forget_my_password } from ".";

const useMutationForgetPassword = ({ onSuccess, onError }) => {
    const { mutate: mutate_forgotten_password, isLoading: loadingRequest } =
        useMutation((email) => _forget_my_password(email), {
            onSuccess,
            onError,
        });
    return {
        mutate_forgotten_password,
        loadingRequest,
    };
};

export default useMutationForgetPassword;
